(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;

  // Trigger the theme's infinite load 2500px before the end of the grid,
  // so the next page is already in place when the customer scrolls fast.
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var wrap = entry.target;
      if (wrap.hasAttribute('loading')) return;
      var trigger = wrap.querySelector('.hdt-pagination__infinite-trigger');
      if (trigger) {
        io.unobserve(wrap);
        trigger.click();
      }
    });
  }, { rootMargin: '0px 0px 2500px 0px' });

  function watch() {
    var wraps = document.querySelectorAll('[loadmore-btn-wrapp]');
    for (var i = 0; i < wraps.length; i++) {
      if (!wraps[i].getAttribute('data-cpw-watched')) {
        wraps[i].setAttribute('data-cpw-watched', '1');
        io.observe(wraps[i]);
      }
    }
  }

  watch();

  // The theme replaces the pagination wrapper after each page loads and on filter changes
  new MutationObserver(watch).observe(document.body, { childList: true, subtree: true });
})();